module.exports = __webpack_public_path__ + "img/alg1.c6782b80.png";